let config = require("../config/config.js")
import axios from "axios";
import helpers from "../helpers.js";

axios.interceptors.response.use(function(response) {
  return response;
}, function(error) {
  if (error.response.data) {
    helpers.error("Ooops: "+error.response.data);  
  } else {
    helpers.error("Ooops: "+error.toString());
  }
  return Promise.reject(error);
})

let baseUrl = process.env.VUE_APP_API_BASE_URL;
if (!baseUrl) baseUrl = config.api;

let setUpConfig = function(method,suffix) {
	let user = localStorage.getItem('user') 
  let token = user?(JSON.parse(user)).token:null;
  let config = {}

  
    if(token) {
      config = {
        headers: { 'Authorization': `Bearer ${token}` },
        method,
        url:baseUrl+suffix
      }
    }
  
    else {
      console.error("No token saved!");
    }
  
   return config; 
}

let language = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","language/all");
      return axios(axiosConfig); 
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "language/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Language: data.Language, Id:0, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "language/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Language: data.Language, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "language/"+Id);
    return axios(axiosConfig);
  }
}

let city = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","city/all");
      return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "city/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {City: data.City, Id:0, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "city/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {City: data.City, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "city/"+Id);
    return axios(axiosConfig);
  }
}

let mode = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","mode/all");
      return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "mode/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Mode: data.Mode, Id:0, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "mode/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Mode: data.Mode, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "mode/"+Id);
    return axios(axiosConfig);
  }
}

let tag = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","tag/all");
      return axios(axiosConfig);
  },

  getByShow: (id) => {
    let axiosConfig = setUpConfig("get","tag/show/"+id);
    return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "tag/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Tag: data.Tag, Id:0, Created:0, Updated:0, Active:data.Active, IsReaction: data.IsReaction};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "tag/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Tag: data.Tag, Id:data.Id, Created:0, Updated:0, Active:data.Active, IsReaction: data.IsReaction};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "tag/"+Id);
    return axios(axiosConfig);
  }
}

let friend = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","friend/all");
      return axios(axiosConfig);
  },

  getByShow: (id) => {
    let axiosConfig = setUpConfig("get","friend/show/"+id);
    return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "friend/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Friend: data.Friend, Id:0, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "friend/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Friend: data.Friend, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "friend/"+Id);
    return axios(axiosConfig);
  }
}

let gameStatus = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","game_status/all");
      return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "game_status/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {GameStatus: data.GameStatus, Id:0, Created:0, Updated:0, Active:data.Active, Timeline:data.Timeline};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "game_status/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {GameStatus: data.GameStatus, Id:data.Id, Created:0, Updated:0, Active:data.Active, Timeline:data.Timeline};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "game_status/"+Id);
    return axios(axiosConfig);
  }
}

let platform = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","platform/all");
      return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "platform/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Platform: data.Platform, Id:0, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "platform/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Platform: data.Platform, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "platform/"+Id);
    return axios(axiosConfig);
  }
}


let seriesStatus = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","series_status/all");
      return axios(axiosConfig);
  },

  getByShow: (id) => {
    let axiosConfig = setUpConfig("get","series_status/show/"+id);
    return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "series_status/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {SeriesStatus: data.SeriesStatus, Id:0, Created:0, Updated:0, Active:data.Active, IsSeason:data.IsSeason};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "series_status/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {SeriesStatus: data.SeriesStatus, Id:data.Id, Created:0, Updated:0, Active:data.Active, IsSeason:data.IsSeason};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "series_status/"+Id);
    return axios(axiosConfig);
  }
}

let service = {
  getAll : () => {
      let axiosConfig = setUpConfig("get","service/all");
      return axios(axiosConfig);
  },

  create : (data) => {
    let axiosConfig = setUpConfig("post", "service/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Name: data.Name, Room: data.Room, Is_tv: data.Is_tv, City_id: data.City_id, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "service/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Name: data.Name, Room: data.Room, Is_tv: data.Is_tv, City_id: data.City_id, Id:data.Id, Created:0, Updated:0, Active:data.Active};
    return axios(axiosConfig);
  },

  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "service/"+Id);
    return axios(axiosConfig);
  }
}

let director = {
  getPaginated: (start,num,filter) => {
    let queryString = "?start="+start+"&num="+num;
    
    if (filter) queryString += "&filter="+filter;
    let axiosConfig = setUpConfig("get","director/paginated"+queryString);
    
      return axios(axiosConfig);
  },
  getTotal: (filter) => {
    let queryString = filter?"?filter="+filter:"";
    
    let axiosConfig = setUpConfig("get","director/total"+queryString);
      return axios(axiosConfig);
  },
  getByMovie: (id) => {
    let axiosConfig = setUpConfig("get","director/movie/"+id);
    return axios(axiosConfig);
  }
}

let game = {
  search: (search) => {
    let axiosConfig = setUpConfig("get","game/rawg/search/"+search);
    return axios(axiosConfig);
  },
  getPaginated: (start,num,filter, order) => {
    let axiosConfig = setUpConfig("post","game/paginated");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {
      start,
      num,
      order_by: order,//"games.status_id, games.title",
      filter
    }
    
      return axios(axiosConfig);
  },
  getTotal: (filter) => {
    let axiosConfig = setUpConfig("post","game/total");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {
      start:0,
      num:0,
      order_by: "games.title desc",
      filter
    }
    
      return axios(axiosConfig);
  },
  details: (id) => {
    let axiosConfig = setUpConfig("get","game/rawg/details/"+id);
    return axios(axiosConfig);
  },
  create : (data) => {
    let axiosConfig = setUpConfig("post", "game/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Title: data.Title, 
      OriginalTitle: data.OriginalTitle, 
      BeginDate: Date.parse(data.DateBeginDate)/1000,
      EndDate: Date.parse(data.DateEndDate)/1000,
      PurchaseDate: Date.parse(data.DatePurchaseDate)/1000,
      PlatformId: data.PlatformId,
      StatusId: data.StatusId,
      ExtId: data.ExtId,
      Comment: data.Comment,
      Dicks: parseFloat(data.Dicks),
      Id:0, Created:0, Updated:0};
    return axios(axiosConfig);
  },

  update : (data) => {
    let axiosConfig = setUpConfig("put", "game/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {Title: data.Title, 
      OriginalTitle: data.OriginalTitle, 
      BeginDate: Date.parse(data.DateBeginDate)/1000,
      EndDate: Date.parse(data.DateEndDate)/1000,
      PurchaseDate: Date.parse(data.DatePurchaseDate)/1000,
      PlatformId: data.PlatformId,
      StatusId: data.StatusId,
      ExtId: data.ExtId,
      Comment: data.Comment,
      Dicks: parseFloat(data.Dicks),
      Id:data.Id, Created:0, Updated:0};
    return axios(axiosConfig);
  },
  delete : function(id) {
    let axiosConfig = setUpConfig("delete", "game/"+id);
    return axios(axiosConfig);
  }
}

let vision = {

  getTmdb: (imdbId) => {
    let axiosConfig = setUpConfig("get","vision/tmdb/"+imdbId);
    return axios(axiosConfig);
  },
  checkImdb: (imdbName) => {
    let axiosConfig = setUpConfig("get","movie/check/"+imdbName);
    return axios(axiosConfig);
  },

  getByDirector: (Id) => {
    let axiosConfig = setUpConfig("get","vision/director/"+Id);
    return axios(axiosConfig);
  },

  getPaginated: (start, num, filter) => {
    if (!filter)
      filter ={} 
    let axiosConfig = setUpConfig("post","vision/paginated/");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {
      start,
      num,
      order_by: "shows.date_seen desc",
      filter
    }
    return axios(axiosConfig);
  },

  getTotal: (filter) => {
    if (!filter)
    filter =[] 
    let axiosConfig = setUpConfig("post","vision/total");
    axiosConfig.data={};
    axiosConfig.data = {
      start:0,
      num:0,
      order_by: "shows.date_seen desc",
      filter
    }
    return axios(axiosConfig);
  },

  create: (extShow) => {
    let axiosConfig = setUpConfig("post", "vision/");
    axiosConfig.headers["Content-Type"] = "application/json";
    extShow.Date_seen = Date.parse(extShow.Date_seen)/1000;
    extShow.Dicks = parseFloat(extShow.Dicks);
    if (!extShow.Tags || extShow.Tags.length == 0)
      extShow.Tags = [];
    if (!extShow.Reactions || extShow.Reactions.length == 0)
      extShow.Reactions = [];
    let allTags = extShow.Tags.concat(extShow.Reactions);
    let vision = {
      Ext_show: extShow,
      Directors: extShow.Directors,
      Friends: extShow.Friends,
      Tags: allTags
    }
    axiosConfig.data = vision;
    return axios(axiosConfig);
  }
  ,

   asinello: (asinello_data) => {
    let axiosConfig = setUpConfig("post", "vision/asinello");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = asinello_data;
    return axios(axiosConfig);
  }
  ,

  update: (extShow) => {
    let axiosConfig = setUpConfig("put", "vision/");
    axiosConfig.headers["Content-Type"] = "application/json";
    extShow.Date_seen = Date.parse(extShow.Date_seen)/1000
    extShow.Dicks = parseFloat(extShow.Dicks)
    if (!extShow.Tags || extShow.Tags.length == 0)
      extShow.Tags = [];
    if (!extShow.Reactions || extShow.Reactions.length == 0)
      extShow.Reactions = [];
    let allTags = extShow.Tags.concat(extShow.Reactions);
    
    let vision = {
      Ext_show: extShow,
      Directors: [],
      Friends: extShow.Friends,
      Tags: allTags
    }
    axiosConfig.data = vision;
    return axios(axiosConfig);
  },
  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "vision/"+Id);
    return axios(axiosConfig);
  }

}

let series = {

  getTmdb: (imdbId) => {
    let axiosConfig = setUpConfig("get","series/tmdb/"+imdbId);
    return axios(axiosConfig);
  },


  getPaginated: (start, num, filter) => {
    if (!filter)
      filter ={}; 
    let axiosConfig = setUpConfig("post","season/paginated");
    axiosConfig.headers["Content-Type"] = "application/json";
    axiosConfig.data = {
      start,
      num,
      order_by: "seasons.date_begin desc",
      filter
    }
    return axios(axiosConfig);
  },

  getTotal: (filter) => {
    if (!filter)
      filter =[]; 
    let axiosConfig = setUpConfig("post","season/total");
    axiosConfig.data={};
    axiosConfig.data =  filter;
    return axios(axiosConfig);
  },

  create: (data) => {
    let axiosConfig = setUpConfig("post", "season/extended");
    axiosConfig.headers["Content-Type"] = "application/json";
    data.Dicks = parseFloat(data.Dicks);
    data.Number = parseInt(data.Number);
    data.Series.YearBegin = parseInt(data.Series.YearBegin);
    data.Series.YearEnd = parseInt(data.Series.YearEnd);
    data.Id = 0;
    data.Created = 0;
    data.Updated = 0;
    data.SeriesId = 0;
    data.DateBegin = Date.parse(data.DateBeginDate)/1000
    data.DateEnd = Date.parse(data.DateEndDate)/1000
    
    axiosConfig.data = data;
    return axios(axiosConfig);
  }
  ,

  update: (data) => {
    let axiosConfig = setUpConfig("put", "season/extended");
    axiosConfig.headers["Content-Type"] = "application/json";
    data.Dicks = parseFloat(data.Dicks);
    data.Number = parseInt(data.Number);
    data.Series.YearBegin = parseInt(data.Series.YearBegin);
    data.Series.YearEnd = parseInt(data.Series.YearEnd);
    data.Created = 0;
    data.Updated = 0;
    data.DateBegin = Date.parse(data.DateBeginDate)/1000
    data.DateEnd = Date.parse(data.DateEndDate)/1000
    axiosConfig.data = data;
    return axios(axiosConfig);
  },
  delete : function(Id) {
    let axiosConfig = setUpConfig("delete", "season/"+Id);
    return axios(axiosConfig);
  }

}

let lovs = () => {
  let axiosConfig = setUpConfig("get","lovs");
  return axios(axiosConfig);
}

let login = function(Username, Password) {
    let data = {Username, Password};
    let axiosConfig = {
        url: baseUrl + "login",
        method: 'post',
        headers: { "Content-Type": "application/json" },
        data: data
    }
    return axios(axiosConfig);

}

let tmdb = {
  getMovie: (id)=>{
    let baseTmdbUrl = "https://api.themoviedb.org/3/movie/__ID__?api_key=6654c27c05e7b5e71661daa057a774b4"
    let url = baseTmdbUrl.replace("__ID__", id)
    return axios.get(url)
  },
  getSeries: (id)=> {
    let baseTmdbUrl = "https://api.themoviedb.org/3/tv/__ID__?api_key=6654c27c05e7b5e71661daa057a774b4"
    let url = baseTmdbUrl.replace("__ID__", id)
    return axios.get(url)
  }
}

let getVersion = () => {
  let axiosConfig = setUpConfig("get","version");
  return axios(axiosConfig);
}

let api = {
    language,
    city,
    mode,
    friend,
    tag,
    game,
    gameStatus,
    platform,
    service,
    seriesStatus,
    director,
    vision,
    lovs,
    login,
    tmdb,
    series,
    getVersion
}

export default api;
